const capitalizeFirstLetterOfString = (string: string) => string.charAt(0).toUpperCase() + string.slice(1); 

const normalizeWhitespace = (string: string) => string.trim().replace(/\s+/g, ' ');

export { capitalizeFirstLetterOfString, normalizeWhitespace }